import { Shield, Zap, Eye, BarChart3, Wallet, Users } from "lucide-react";

const WAVE_IMG =
  "https://static.prod-images.emergentagent.com/jobs/d6d87f76-c4a8-410a-8b53-e45e296abac9/images/661af261bd546b0d6fed3c11b5613b35a53d68a6ef0099f0d6c3dc5b80f7ca0f.png";

const FEATURES = [
  {
    icon: Shield,
    title: "OAuth-secure login",
    desc: "We never see your Deriv password. Connect via Deriv's official OAuth handshake.",
  },
  {
    icon: Zap,
    title: "Sub-second execution",
    desc: "Direct WebSocket pipe to Deriv. Quotes refresh in real time, trades execute instantly.",
  },
  {
    icon: BarChart3,
    title: "103-strategy Auto Bot",
    desc: "A 24/7 server-side bot that live-accredits its strategies and only fires the proven winners — no phone needed.",
  },
  {
    icon: Eye,
    title: "Over 3 Quick Bot",
    desc: "1-tick digit bot with single-trade recovery, a hard depth cap, and an Auto-Stake advisor that shows the worst case before you start.",
  },
  {
    icon: Users,
    title: "Copy trading + referrals",
    desc: "Mirror the desk's Pro Trades automatically, or invite friends and earn a cut of the volume they generate.",
  },
  {
    icon: Wallet,
    title: "Smart-Secure profit lock",
    desc: "Winning Pro Trades ladder into smaller contracts to bank partial profit before expiry — automatically.",
  },
];

const WhyVts = () => {
  return (
    <section
      data-testid="why-vts-section"
      className="relative py-24 lg:py-32 border-t border-vts-line overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-1/2 z-0 pointer-events-none opacity-50">
        <img src={WAVE_IMG} alt="" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-5 lg:px-8">
        <div className="max-w-2xl mb-16">
          <div className="text-xs uppercase tracking-[0.25em] text-vts-blue font-semibold mb-4">
            05 — Why VTS
          </div>
          <h2 className="font-heading font-bold text-4xl sm:text-5xl text-white tracking-tighter">
            Built for beginners.<br />
            <span className="text-vts-silver">Engineered for pros.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-vts-line border border-vts-line rounded-md overflow-hidden">
          {FEATURES.map((f, idx) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                data-testid={`why-feature-${idx}`}
                className="bg-vts-bg hover:bg-vts-surface p-7 transition group"
              >
                <div className="h-10 w-10 rounded-md border border-vts-line bg-vts-surface flex items-center justify-center mb-5 group-hover:border-vts-blue/50 group-hover:bg-vts-blue/10 transition">
                  <Icon className="h-5 w-5 text-vts-blue" />
                </div>
                <h3 className="font-heading font-semibold text-lg text-white mb-2 tracking-tight">
                  {f.title}
                </h3>
                <p className="text-sm text-vts-silver/70 font-body leading-relaxed">
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyVts;
